export const STATUSES = {
  bozza: { label: "Bozza", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  in_lavorazione: { label: "In lavorazione", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  pronto: { label: "Pronto per presentazione", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  archiviato: { label: "Archiviato", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export const PROJECT_TYPES = [
  { value: "sito_vetrina", label: "Sito vetrina" },
  { value: "sito_aziendale", label: "Sito aziendale" },
  { value: "ecommerce", label: "E-commerce" },
  { value: "prenotazione", label: "Sistema di prenotazione" },
  { value: "landing", label: "Landing page" },
  { value: "web_app", label: "Applicazione web" },
  { value: "dashboard", label: "Dashboard gestionale" },
  { value: "altro", label: "Altro" },
];

export const STYLES = ["Luxury", "Minimal", "Corporate", "Editorial", "Moderno", "Creativo", "Tecnologico", "Elegante", "Sportivo", "Personalizzato"];

export const LANGUAGES = [
  { value: "it", label: "Italiano" },
  { value: "es", label: "Spagnolo" },
  { value: "en", label: "Inglese" },
  { value: "fr", label: "Francese" },
  { value: "de", label: "Tedesco" },
  { value: "pt", label: "Portoghese" },
];

export const FONTS = [
  "Fraunces", "Playfair Display", "Cormorant Garamond", "DM Serif Display", "Instrument Serif", "Libre Baskerville",
  "Bodoni Moda", "Marcellus", "Italiana", "Lora", "Syne", "Space Grotesk", "Outfit", "Manrope", "DM Sans", "Work Sans",
  "Figtree", "Sora", "Archivo", "Bricolage Grotesque", "Unbounded", "Bebas Neue", "Oswald", "Barlow", "Karla", "Jost",
  "Urbanist", "Red Hat Display", "IBM Plex Sans", "Nunito Sans",
];

export const COLOR_TOKENS = [
  { key: "primary", label: "Principale" },
  { key: "secondary", label: "Secondario" },
  { key: "accent", label: "Accento" },
  { key: "base", label: "Sfondo pagina" },
  { key: "surface", label: "Superfici / card" },
  { key: "ink", label: "Testo" },
  { key: "muted", label: "Testo secondario" },
];

export const ORIGINS = {
  libreria: { label: "Libreria", cls: "bg-emerald-50 text-emerald-700" },
  ai: { label: "AI", cls: "bg-sky-50 text-sky-700" },
  predefinito: { label: "Predefinito", cls: "bg-slate-100 text-slate-600" },
  custom: { label: "Personalizzato", cls: "bg-violet-50 text-violet-700" },
  manual: { label: "Manuale", cls: "bg-slate-100 text-slate-600" },
};

export const DEVICES = {
  desktop: { label: "Desktop", width: "100%" },
  tablet: { label: "Tablet", width: 820 },
  mobile: { label: "Smartphone", width: 390 },
};
